import { render, staticRenderFns } from "./chooselink.vue?vue&type=template&id=20b18e5a&scoped=true&"
import script from "./chooselink.vue?vue&type=script&lang=js&"
export * from "./chooselink.vue?vue&type=script&lang=js&"
import style0 from "./chooselink.vue?vue&type=style&index=0&id=20b18e5a&prod&lang=css&"
import style1 from "./chooselink.vue?vue&type=style&index=1&id=20b18e5a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b18e5a",
  null
  
)

export default component.exports